var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-card"},[_c('h3',{staticClass:"text-center"},[_vm._v("\n    "+_vm._s(_vm.$t('pages.user-cv.sidebar.find-courses', 'Find courses'))+"\n  ")]),_c('Courses')],1)}
var staticRenderFns = []

export { render, staticRenderFns }